:host {
  display: block;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
}

::slotted(a) {
  text-decoration: none;
}

::slotted(a:hover) {
  opacity: 0.7;
}

::slotted(lilu-p:hover) {
  opacity: 0.7;
}
